export default {
    cssPXStrToInt: function(str) {
        return parseInt(
                str.substring(0, str.length - 2)
            )
    },
    intPXToCssStr: function(value) {
        return value + "px"
    },
}